import {defineStore} from 'pinia'

export const useAxilwebGeoSearchAppStore = defineStore('axilwebGeoSearchApp', {
    state: () => ({
        axilwebGeoSearchApp: axilwebGeoSearchPublicConfig,
        settings: {},
        authorized: {},
        abort_code: 0,
        abort_message: '',
        sidebar: [],
        sidebarAll: [],
    }),
    getters: {
        getAxilwebApp: state => state.axilwebGeoSearchApp,
        isUserLoggedIn: state => !!state.axilwebGeoSearchApp?.isLoggedIn,
        getAuthor: state => state.authorized?.author,
        getSidebar: state => state.sidebar,
        getPermissions: state => state.authorized?.author?.permissions,
        getHomeRoute: state => state.axilwebGeoSearchApp?.home_route,

        getSettings: state => state.axilwebGeoSearchApp?.settings,
        getRowsPerPage: state => state.axilwebGeoSearchApp?.settings?.rows_per_page,
        getAbortCode: state => state.abort_code,
        getAbortMessage: state => state.abort_message,
    },
    actions: {
        async setAbort(code = 0, message = ''){
            this.abort_code = code;
            if(message){
                this.abort_message = message;
            }
        },

        async delay(ms){
            return new Promise(resolve => setTimeout(resolve, ms));
        },

        async authorization() {
            return axios.get('/app/authorization')
                .then((resp) => {
                    this.authorized = resp?.data?.authorized;
                    this.sidebarAll = resp?.data?.authorized?.author?.sidebar;
                    this.axilwebGeoSearchApp = resp?.data?.axilwebGeoSearchApp;
                })
                .catch((error) => {
                    if (error?.response?.status === 401) {
                        commit('RESET_AUTHORIZATION');
                    }
                })
        },
    }
});
